import { render, staticRenderFns } from "./CreateOfferStudioUser.vue?vue&type=template&id=b5304be6"
import script from "./CreateOfferStudioUser.vue?vue&type=script&lang=js"
export * from "./CreateOfferStudioUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports